<template>
    <div class="ml-2">
        <b-button variant="danger" @click.stop="abrirModal()">
            <i class="fa fa-times-circle"></i> Devolver Solicitação
        </b-button>
        <b-modal
            :visible="mostrarModal"
            @hide="fecharModal"
            hide-footer
            title="Reprovar solicitação de requisição"
            centered
        >
            <b-alert v-if="erros.length" variant="danger" show>
                <div v-for="(erro, idx) in erros" :key="idx">{{ erro }}</div>
            </b-alert>
            <b-form-group
                label="Justificativa"
                label-for="justificativa-input"
                label-class="required"
            >
                <b-form-textarea
                    id="justificativa-input"
                    v-model="justificativa"
                    :rows="4"
                    :limit="1000"
                    placeholder="Informe a justificativa"
                ></b-form-textarea>
            </b-form-group>
            <div class="d-flex justify-content-end">
                <b-button variant="secondary" class="mr-2" @click="fecharModal"
                    >Cancelar</b-button
                >
                <b-button
                    variant="danger"
                    :disabled="!justificativaPreenchida"
                    @click="reprovarSolicitacao"
                    >Devolver</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import RequisicoesServicos from './RequisicoesServicos'

export default {
    props: {
        requisicao: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            mostrarModal: false,
            justificativa: '',
            erros: []
        }
    },
    methods: {
        abrirModal() {
            this.justificativa = ''
            this.erros = []
            this.mostrarModal = true
        },
        fecharModal() {
            this.mostrarModal = false
        },
        reprovarSolicitacao() {
            this.erros = []
            if (!this.justificativa || this.justificativa.trim() === '') {
                this.erros.push('A justificativa é obrigatória.')
                return
            }
            this.$store.dispatch('addRequest')
            const idRequisicao = this.$route.params.idRequisicao
            RequisicoesServicos.reprovarSolicitacaoRequisicao({
                idRequisicao: idRequisicao,
                justificativa: this.justificativa
            }).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$emit('obterRequisicaoAtualizada')
                        this.$store.dispatch('setRecarregar', true)
                        this.$toast.success(
                            'Solicitação devolvida com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.mostrarModal = false
                    } else {
                        this.erros = response.errors || [
                            'Erro ao reprovar a solicitação.'
                        ]
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
    computed: {
        justificativaPreenchida() {
            return (
                this.justificativa != null && this.justificativa.trim() !== ''
            )
        }
    }
}
</script>
